import { schoolTokenAxios } from "../axios";

const SCHOOL_REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;
let school_access_url = `${SCHOOL_REPORTING_BASE}/schoolAccess`;

export const getModuleWithScreenNameList = (params) => {
  return schoolTokenAxios.get(
    `${school_access_url}/getModuleWithScreenNameList`,
    {
      params: params,
    }
  );
};
